/**
 * Auto-generated version file
 * DO NOT EDIT MANUALLY - This file is generated by scripts/sync-version.ts
 * Run 'bun run sync-version' to update
 */

export const PKG_VERSION = '0.1.0';
